/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientContent } from '../../models/client-content';
import { ClientContentApiRespModel } from '../../models/client-content-api-resp-model';

export interface ApiMasterClientContentEditPost$Params {
      body?: ClientContent
}

export function apiMasterClientContentEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterClientContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterClientContentEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientContentApiRespModel>;
    })
  );
}

apiMasterClientContentEditPost.PATH = '/api/Master/ClientContent/Edit';
